import { ReactElement } from "react"

import AmendEVACDeviceForm from "../../../../components/devices/lct/evac/amendEVACDeviceForm"
import ContinueEVACDeviceAmendmentProvider from "../../../../components/devices/lct/evac/providers/continueEVACDeviceAmendmentProvider"

const ContinueEVACDraftDeviceAmendment = (): ReactElement => (
    <ContinueEVACDeviceAmendmentProvider>
        <AmendEVACDeviceForm />
    </ContinueEVACDeviceAmendmentProvider>
)

export default ContinueEVACDraftDeviceAmendment
